import 'css-chunksrc/client/common/filterMenu/zones/zone/projects/styles.scss';export default {
  "projects": "_projects_17h61_1"
};